// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__EeErA","info":"UpdateTermsInfo_info__WJC6N"};